import { ButtonHeaderCloseComponent } from './button-header-close.component';

export default angular
  .module('sfMobile.components.button-header-close', [])
  .component('sfButtonHeaderClose', ButtonHeaderCloseComponent).name;
